import { ActionIcon, Flex, type MantineSize, Radio, Tooltip } from "@mantine/core";
import { useUncontrolled } from "@mantine/hooks";
import { IconX } from "@tabler/icons-react";
import type { Grade } from "../../models/enums/grade";
import styles from "./ResetableRadio.module.css";

type ResetableRadioGroupProps = {
  value?: string;
  defaultValue?: string;
  onChange: (selected: string) => void;
  radios: { value: string; label: string | undefined }[];
  onReset: () => void;
  resetLabel?: string;
  size?: MantineSize;
  radioFlex?: number;
  topLabel?: boolean;
  selfAssessmentValue?: Grade;
};

export function ResetableRadioGroup({
  value,
  defaultValue,
  onChange,
  onReset,
  radios,
  resetLabel = "Zurücksetzen",
  size,
  selfAssessmentValue,
}: ResetableRadioGroupProps) {
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    onChange,
    finalValue: "",
  });

  const isSelfAssessmentSelection = (value: string) => selfAssessmentValue && selfAssessmentValue === value;

  return (
    <>
      <Radio.Group flex={4} onChange={setValue} value={_value}>
        <Flex justify="space-around">
          {radios.map((r) => (
            <Radio
              key={r.value}
              label={r.label}
              value={r.value}
              size={size}
              className={isSelfAssessmentSelection(r.value) ? styles.selfAssessmentMarking : undefined}
            />
          ))}
        </Flex>
      </Radio.Group>
      <Tooltip label={resetLabel} onClick={() => onReset()}>
        <ActionIcon variant="subtle" color="default">
          <IconX />
        </ActionIcon>
      </Tooltip>
    </>
  );
}
